import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { SignUpSuccessWidget } from '@/bundle/Auth/AdminOnboardingFlow/SignUpPage/ui/SignUpSuccessWidget';
import { SignUpForm } from '@/bundle/Auth/AdminOnboardingFlow/SignUpPage/ui/SignUpForm';
import { useState } from 'react';
import { AuthHeading } from '../../ui/AuthHeading/AuthHeading';
import { Box } from '@/components/Box/Box';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { useAuthNavigateToStep } from '../../hooks/useAuthNavigateToStep';
import { CreateUnauthorizedOrganizationResponseType } from '@/api/v1/organization/unauthorized/createUnauthorizedOrganizationApi';
import { AdminOnboardingStepper } from '../ui/AdminOnboardingStepper';
import { SIGN_UP_STEP } from '@/const/shared';

type SignUpFormSuccessResponseType = {
  response: CreateUnauthorizedOrganizationResponseType;
  email: string;
};

export const SignUpPage = () => {
  const [email, setEmail] = useState('');
  const [showForm, setShowForm] = useState(true);
  const navigateToStep = useAuthNavigateToStep();

  const onSuccess = ({ response, email }: SignUpFormSuccessResponseType) => {
    setEmail(email);
    amplitudeService.logEvent(AMPLITUDE_EVENTS.SignUpFormSuccess);

    // If <auth_token> has a value then navigate it to next onboarding step -> new user and organization created
    // If <auth_token> is empty then show the success modal and end flow -> existing user or organization.
    if (response?.auth_token) {
      return navigateToStep(response, { state: { email } });
    }

    setShowForm(false);
  };

  return (
    <AuthLayout banner={showForm && <AdminOnboardingStepper signUpStep={SIGN_UP_STEP.ONBOARDING} />}>
      {showForm ? (
        <Box display='flex' flexDirection='column' alignItems='center' marginBottom='68px'>
          <AuthHeading
            header='Secure Your First Wire in Under 5 Minutes'
            subHeader='Create your account and securely share and collect wire instructions today. No integration required.'
          />

          <SignUpForm onSuccess={onSuccess} />
        </Box>
      ) : (
        <SignUpSuccessWidget email={email} />
      )}
    </AuthLayout>
  );
};
